import script from "./ProfileTeams.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileTeams.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileTeams.vue?vue&type=style&index=0&id=45676770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45676770"]])

export default __exports__